// StoreContext.tsx
import { createContext, ReactNode, useContext } from 'react';

import CompanyRepository from './CompanyRepository/CompanyRepository';
import MessageChatRepository from './MessageChatRepository/MessageChatRepository';
import PackageItemRepository from './PackageItemRepository/PackageItemRepository';
import PackageRepository from './PackageRepository/PackageRepository';
import ReceptionRepository from './ReceptionRepository/ReceptionRepository';
import { ServiceOrderRepository } from './ServiceOrderRepository/ServiceOrderRepository';
import ShipmentRepository from './ShipmentRepository/ShipmentRepository';
import TicketRepository from './TicketRepository/TicketRepository';
import UserRepository from './UserRepository/UserRepository';

interface repositoriesContextType {
  ticketRepository: TicketRepository;
  shipmentRepository: ShipmentRepository;
  receptionRepository: ReceptionRepository;
  packageRepository: PackageRepository;
  packageItemRepository: PackageItemRepository;
  userRepository: UserRepository;
  companyRepository: CompanyRepository;
  serviceOrderRepository: ServiceOrderRepository;
  messageChatRepository: MessageChatRepository;
}

const RepositoriesContext = createContext<repositoriesContextType>({} as repositoriesContextType);

export const RepositoriesProvider = ({
  children,
  axiosInstance,
}: {
  children: ReactNode;
  axiosInstance: any;
}) => (
  <RepositoriesContext.Provider
    value={{
      ticketRepository: new TicketRepository(axiosInstance),
      shipmentRepository: new ShipmentRepository(axiosInstance),
      receptionRepository: new ReceptionRepository(axiosInstance),
      packageRepository: new PackageRepository(axiosInstance),
      packageItemRepository: new PackageItemRepository(axiosInstance),
      userRepository: new UserRepository(axiosInstance),
      companyRepository: new CompanyRepository(axiosInstance),
      serviceOrderRepository: new ServiceOrderRepository(axiosInstance),
      messageChatRepository: new MessageChatRepository(axiosInstance),
    }}>
    {children}
  </RepositoriesContext.Provider>
);

export const useRepositoriesContext = () => useContext(RepositoriesContext);
